module.exports = __webpack_public_path__ + "static/media/doswnload.1216c0f6.svg";